<template>
  <div class="q-pa-md">
    <div class="row justify-center q-my-md" v-show="loading">
        <q-spinner-dots color="primary" size="40px" />
    </div>
    <div class="container">
      <!-- Cabeçalho -->
      <div class="q-mb-xl">
        <q-btn
          class="gt-sm q-ml-md"
          color="primary"
          label="Publicar Imóvel"
          icon="add_circle"
          unelevated
          to="/imovel/adicionar"
        />
        <!-- <h2 class="text-h3 text-weight-bold text-grey-9 q-mb-sm">
          Meus Imoveis
        </h2> -->
        
      </div>

      <!-- Grid de Cards -->
      <q-infinite-scroll @load="onLoad" :offset="250">
        <div class="row q-col-gutter-lg">
          <div
            v-for="(imovel, index) in imoveis"
            :key="index"
            class="col-12 col-sm-6 col-md-3"
          >
            <q-card class="imovel-card" flat bordered>
              <!-- Badges -->
              <div class="badge-container">
                <!-- Badge de Tipo de Negócio -->
                <q-badge
                  :color="imovel.objective === 'Venda' ? 'green-7' : 'blue-7'"
                  floating
                  class="tipo-negocio-badge"
                >
                  {{ imovel.objective }}
                </q-badge>
                
              </div>

              <!-- Imagem do Imóvel -->
              <div class="image-container">
                <q-img
                  :src="imovel.primary_image_url"
                  :ratio="16/10"
                  class="cursor-pointer"
                  @click="verDetalhes(imovel)"
                >
                  <template v-slot:loading>
                    <q-spinner-gears color="primary" />
                  </template>
                </q-img>
                
                <!-- Overlay com botão favorito -->
                <!-- <div class="image-overlay">
                  <q-btn
                    round
                    flat
                    dense
                    icon="favorite_border"
                    color="white"
                    size="md"
                    @click.stop="toggleFavorito(index)"
                  />
                </div> -->
              </div>

              <q-card-section>
                <!-- Tipo do Imóvel -->
                <div class="text-overline text-primary q-mb-xs">
                  {{ imovel.property_type }}
                </div>

                <!-- Título -->
                <div class="text-h6 text-weight-bold q-mb-sm ellipsis-2-lines">
                  {{ imovel.title }}
                </div>

                <!-- Localização -->
                <div class="row items-center q-mb-md text-grey-7">
                  <q-icon name="location_on" size="18px" class="q-mr-xs" />
                  <span class="text-body2">{{ imovel.location }}</span>
                </div>

                <!-- Características -->
                <div class="row items-center q-gutter-md q-mb-md">
                  <div class="row items-center">
                    <q-icon name="bed" size="20px" color="grey-7" />
                    <span class="q-ml-xs text-body2 text-weight-medium">
                      {{ imovel.bedroom_amount }}
                    </span>
                  </div>
                  <div class="row items-center">
                    <q-icon name="bathtub" size="20px" color="grey-7" />
                    <span class="q-ml-xs text-body2 text-weight-medium">
                      {{ imovel.bathroom_amount }}
                    </span>
                  </div>
                  <div class="row items-center">
                    <q-icon name="square_foot" size="20px" color="grey-7" />
                    <span class="q-ml-xs text-body2 text-weight-medium">
                      {{ imovel.area }}m²
                    </span>
                  </div>
                  <div class="row items-center">
                    <q-icon name="garage" size="20px" color="grey-7" />
                    <span class="q-ml-xs text-body2 text-weight-medium">
                      {{ imovel.garage_space }}
                    </span>
                  </div>
                  <div class="row items-center">
                    <q-icon name="visibility" size="20px" color="grey-7" />
                    <span class="q-ml-xs text-body2 text-weight-medium">
                      {{ imovel.clicks }}
                    </span>
                  </div>
                </div>

                <q-separator class="q-my-md" />

                <!-- Preço e Botão -->
                <div class="row items-center justify-between">
                  <div>
                    <!-- <div class="text-caption text-grey-7">
                      {{ imovel.objective }}
                    </div> -->
                    <div class="text-h5 text-weight-bold text-secondary">
                      {{ formatPrice(imovel.price, imovel.currency) }}
                    </div>
                  </div>
                  <q-btn
                    round
                    color="secondary"
                    icon="arrow_forward"
                    size="md"
                    @click="verDetalhes(imovel)"
                  />
                </div>
              </q-card-section>
            </q-card>
          </div>
        </div>
        <div v-if="!loading && imoveis.length === 0" class="text-center q-py-xl justify-center">
          <q-icon name="home_work" size="80px" color="grey-5" class="q-mb-md" />
          <h4 class="text-h5 text-grey-7 q-mb-sm">Nenhum imóvel encontrado</h4>
          <p class="text-body1 text-grey-6">
            Ainda não publicou nenhum imóvel.
          </p>
        </div>

        <template v-slot:loading>
          <div class="row justify-center q-my-md" v-if="loading">
            <q-spinner-dots color="primary" size="40px" />
          </div>
        </template>
      </q-infinite-scroll>

      <!-- Paginação -->
      <div class="row justify-center q-mt-xl">
        <q-pagination
          v-model="currentPage"
          :max="totalPages"
          :max-pages="6"
          direction-links
          boundary-links
          color="primary"
          active-design="unelevated"
          active-color="primary"
          active-text-color="white"
          @update:model-value="getProperties(currentPage)"
        />
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import store from '@/vuex/store';
import router from '@/router';

const currentPage = ref(1);
const totalPages = ref(1);
let loading = ref(true);

// Dados dos imóveis (simulação)
const imoveis = ref([]);
onMounted(() => {
  getProperties();
});
// getProperties();
function getProperties(page=1) {
  imoveis.value = [];
  loading.value = true;
  store.dispatch('imovel/getImovel', page).then(() => {
    // imoveis.value = store.state.imoveis;
    imoveis.value = store.state.imovel.data.data;
    totalPages.value = store.state.imovel.data.last_page;
    loading.value = false;
    // console.log('Imóveis carregados:', imoveis.value);
  });
}




const formatPrice = (price, currency) => {
  return new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: currency,
    minimumFractionDigits: 0
  }).format(price);
};

const verDetalhes = (imovel) => {
  console.log('Ver detalhes do imóvel:', imovel);
  // useRouter().push(`/imovel/${imovel.slug}`);
  router.push({ name: 'imovel-details', params: { slug: imovel.slug } });
  // Aqui você navegaria para a página de detalhes
};

// const toggleFavorito = (index) => {
//   console.log('Toggle favorito:', index);
// };

const onLoad = (index, done) => {
  // Simula carregamento infinito
  setTimeout(() => {
    done();
  }, 500);
};

</script>

<style scoped>
.container {
  max-width: 1400px;
  margin: 0 auto;
}

.imovel-card {
  height: 100%;
  transition: all 0.3s ease;
  border-radius: 16px;
  overflow: hidden;
}

.imovel-card:hover {
  transform: translateY(-8px);
  box-shadow: 0 12px 24px rgba(0, 0, 0, 0.15);
}

.image-container {
  position: relative;
  overflow: hidden;
}

.image-overlay {
  position: absolute;
  top: 12px;
  right: 12px;
  opacity: 0;
  transition: opacity 0.3s ease;
}

.imovel-card:hover .image-overlay {
  opacity: 1;
}

.badge-container {
  position: relative;
}

.tipo-negocio-badge {
  position: absolute;
  top: 225px;
  left: 120px;
  z-index: 1;
  padding: 6px 12px;
  font-weight: 600;
  letter-spacing: 0.5px;
}

.destaque-badge {
  position: absolute;
  top: 16px;
  right: 16px;
  z-index: 1;
  padding: 6px 12px;
  font-weight: 600;
  letter-spacing: 0.5px;
}

.ellipsis-2-lines {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  min-height: 56px;
}

.q-img {
  transition: transform 0.3s ease;
}

.imovel-card:hover .q-img {
  transform: scale(1.05);
}
</style>